module.exports = __webpack_public_path__ + "static/img/4.826fa16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/4.png
// module id = 9H/f
// module chunks = 35